"use strict";

/**
 * @namespace
 */
gc.gis.format = gc.gis.format || {};

/**
 * @classdesc
 * Abstrakte Wrapperklasse für Reader-/Writer-Funktionalitäten.
 *
 * @class
 * @abstract
 * @extends Object
 * @memberof gc.gis.format
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.format.GCFormat = function()
{
};
gc.gis.format.GCFormat.prototype = Object.create(Object.prototype);

/**
 * Liest eine Vektorgeometrie in ein entsprechendes Geometrie-Objekt ein.
 *
 * @public
 * @abstract
 * @method
 * @param {*} geometry Geometrie
 * @param {string} format Formatstring der Geometrie
 * @param {string} [opt_crs] Optionale Projektion der übergebenen
 *   Geometrie. Default ist {@link gc.gis.map.GCMapView#getProjection}
 * @return {gc.gis.geom.GCGeometry}
 * @throws {gc.gis.error.GCError} sofern die Geometrie nicht verarbeitet werden kann
 */
gc.gis.format.GCFormat.prototype.readGeometry = gc.gis.abstractMethod;

/**
 * Liest eine Liste von Vektorgeometrien in ein entsprechendes Geometrie-Objekt ein.
 *
 * @public
 * @abstract
 * @method
 * @param {*[]} geometries Liste der Geometrien
 * @param {string} format Formatstring der Geometrien
 * @param {string} [opt_crs] Optionale Projektion der übergebenen
 *   Geometrien. Default ist {@link gc.gis.map.GCMapView#getProjection}
 * @return {gc.gis.geom.GCGeometry}
 * @throws {gc.gis.error.GCError} sofern eine Geometrie nicht verarbeitet werden kann
 */
gc.gis.format.GCFormat.prototype.readGeometryList = gc.gis.abstractMethod;

/**
 * Serialisiert eine Geometrie in das angegebene Format.
 *
 * @public
 * @abstract
 * @method
 * @param {gc.gis.geom.GCGeometry} geometry Geometrie
 * @param {string} format gewünschtes Ausgabeformat
 * @return {string}
 * @throws {gc.gis.error.GCError} sofern das Feature nicht verarbeitet werden kann
 */
gc.gis.format.GCFormat.prototype.writeGeometry = gc.gis.abstractMethod;

/**
 * Serialisiert eine Geometrie in das GeoJSON-Format und liefert es als Objekt zurück.
 *
 * @public
 * @abstract
 * @method
 * @param {gc.gis.geom.GCGeometry} geometry Geometrie
 * @return {Object}
 * @throws {gc.gis.error.GCError} sofern das Feature nicht verarbeitet werden kann
 */
gc.gis.format.GCFormat.prototype.writeGeometryObject = gc.gis.abstractMethod;

/**
 * Serialisiert ein Feature in das angegebene Format.
 *
 * @public
 * @abstract
 * @method
 * @param {gc.gis.feature.GCFeature} feature Feature
 * @param {string} format Formatstring
 * @return {string}
 * @throws {gc.gis.error.GCError} sofern das Feature nicht verarbeitet werden kann
 */
gc.gis.format.GCFormat.prototype.writeFeature = gc.gis.abstractMethod;

/**
 * Serialisiert ein Feature in das GeoJSON-Format und liefert es als Objekt zurück.
 *
 * @public
 * @abstract
 * @method
 * @param {gc.gis.feature.GCFeature} feature Feature
 * @return {Object}
 * @throws {gc.gis.error.GCError} sofern das Feature nicht verarbeitet werden kann
 */
gc.gis.format.GCFormat.prototype.writeFeatureObject = gc.gis.abstractMethod;